import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import _replaceAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/replace-all";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GenericModal from "@Shared/components/modals/generic-modal.vue";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { getSecureAccountsApi, putS3Data } from "@Shared/utils/ajax";
import { S3_PUBLIC_DOCUMENT_ENDPOINT, S3_SIGNATURE_BUCKET_URL, showToast } from "@Shared/utils/constants";
import MaterialInput from "../../../../../../shared/components/inputs/material-input.vue";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SaveTemplateModal",
  components: {
    GenericModal,
    MaterialInput,
    SimpleButton
  },
  mixins: [validationMixin],
  validations: {
    templateName: {
      required
    }
  },
  props: {
    html: {
      type: String,
      required: true
    },
    loadedTemplate: {
      type: Object,
      required: true
    },
    saveAsNew: {
      type: Boolean,
      required: true
    },
    savingTemplate: {
      type: Boolean,
      default: false
    },
    subject: {
      type: String,
      default: ""
    },
    attachments: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      templateName: this.loadedTemplate.name,
      templateDescription: this.loadedTemplate.description,
      templateSubject: this.subject,
      uploadingAttachment: false,
      displayedAttachments: Array.isArray(this.attachments) ? [...this.attachments] : []
    };
  },
  computed: {
    isValid() {
      return !this.$v.$invalid;
    }
  },
  watch: {
    attachments: {
      handler(newAttachments) {
        this.displayedAttachments = Array.isArray(newAttachments) ? [...newAttachments] : [];
      },
      immediate: true
    },
    loadedTemplate({
      description,
      name
    }) {
      this.templateDescription = description;
      this.templateName = name;
    }
  },
  mounted() {
    this.templateSubject = this.subject;
  },
  methods: {
    removeAttachment(index) {
      var _context;
      _spliceInstanceProperty(_context = this.displayedAttachments).call(_context, index, 1);
    },
    openAttachmentPicker() {
      var _this$$refs$attachmen;
      (_this$$refs$attachmen = this.$refs.attachmentInput) == null ? void 0 : _this$$refs$attachmen.click();
    },
    async uploadAttachment(file) {
      var _context2;
      const name = _replaceAllInstanceProperty(_context2 = file.name).call(_context2, " ", "-");
      const signed = await getSecureAccountsApi({
        attachment: true,
        fileName: name
      }, S3_PUBLIC_DOCUMENT_ENDPOINT);
      await putS3Data(file, signed.url);
      return {
        url: `${S3_SIGNATURE_BUCKET_URL}/${signed.documentId}`,
        fileName: name,
        documentId: signed.documentId,
        contentType: signed.contentType,
        size: file.size
      };
    },
    async handleAttachmentUpload(event) {
      var _context3;
      const input = event.currentTarget;
      const file = input.files && input.files[0];
      if (!file) return;
      const totalAttachmentSize = file.size + _reduceInstanceProperty(_context3 = this.displayedAttachments).call(_context3, (total, attachment) => {
        return total + (attachment.size || 0);
      }, 0);
      if (totalAttachmentSize >= 26000000) {
        showToast("error", "attachmentSize");
        input.value = "";
        return;
      }
      this.uploadingAttachment = true;
      try {
        const uploadedAttachment = await this.uploadAttachment(file);
        this.displayedAttachments = [...this.displayedAttachments, uploadedAttachment];
      } catch (error) {
        showToast("error", "cantUploadFile");
      } finally {
        this.uploadingAttachment = false;
        input.value = "";
      }
    },
    saveTemplate() {
      if (!this.isValid) return;
      const {
        templateName,
        templateDescription,
        templateSubject,
        displayedAttachments
      } = this;
      this.$emit("save", templateName, templateDescription, isEmpty(templateSubject) ? this.subject : templateSubject, [...displayedAttachments]);
    },
    handleShow() {
      this.templateName = this.loadedTemplate.name;
      this.templateDescription = this.loadedTemplate.description;
      this.templateSubject = this.subject;
      this.uploadingAttachment = false;
      this.displayedAttachments = Array.isArray(this.attachments) ? [...this.attachments] : [];
      this.$v.$reset();
    },
    handleHide() {
      this.templateDescription = "";
      this.templateName = "";
      this.templateSubject = "";
      this.uploadingAttachment = false;
      this.displayedAttachments = Array.isArray(this.attachments) ? [...this.attachments] : [];
      this.$v.$reset();
      this.$emit("hide");
    }
  }
});